import React, { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  user?: any
  customHeading?: ReactNode
}

export const UserHeading = ({ user, customHeading }: Props) => {
  const firstName = user?.name?.split(' ')[0] || ''

  return (
    <h1 className="text-center my-heading-md">
      {!customHeading && firstName && (
        <FormattedMessage
          description="Thank the identified user for an successful order"
          defaultMessage="Thank you, {firstName}!"
          id="tYXlQL"
          values={{ firstName }}
        />
      )}

      {!customHeading && !firstName && (
        <FormattedMessage
          description="Thank the user for an successful order"
          defaultMessage="Thank you!"
          id="t5cpYU"
        />
      )}

      {customHeading}
    </h1>
  )
}
